module.exports = __webpack_public_path__ + "img/dne-app.2a65f5f0.svg";